import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { noop } from 'lodash';
import moment from 'moment';

import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { getParticularPreferenceSettings } from '../../../../common/selectors/preference';
import './DateTimeField.css';
import Message from './ValidationMessage';

class DateTimeFiled extends Component {
  constructor() {
    super();
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  _formatDate(date) {
    if (!date || !moment(date).isValid()) return null;
    return new Date(date);
  }

  handleOnChange(value) {
    const { change, formId, input, isLocal } = this.props;
    const { name } = input;

    const formatLocale = 'YYYY-MM-DDTHH:mm:ss.SSS';
    const datetime = !isLocal
      ? moment(value).toISOString()
      : moment(value).format(formatLocale);
    change(formId, name, datetime);
  }

  render() {
    const {
      intl,
      translation,
      input,
      minDate,
      maxDate,
      required,
      meta: { touched, error, warning },
      options = {},
      dateTimeFormat,
      timeFormat,
    } = this.props;
    let { label } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;

      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    const { value } = input;

    const showError = touched && error ? 'error' : '';
    const requiredLabel = required ? 'required' : '';

    const min = this._formatDate(minDate) || undefined;
    const max = this._formatDate(maxDate) || undefined;
    const valDate = this._formatDate(value);

    const dates = {
      min,
      max,
      value: valDate,
    };

    return (
      <div className={`${requiredLabel} field ${showError}`}>
        <label>{label}</label>
        <div>
          <DateTimePicker
            {...input}
            onBlur={noop}
            onChange={this.handleOnChange}
            format={dateTimeFormat}
            timeFormat={timeFormat}
            readOnly={options.readOnly}
            {...dates}
          />
          <div>
            <Message show={touched} message={error} />
            <Message show={touched} message={warning} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const timeFormat = (
    getParticularPreferenceSettings(state, 'time_format', ['value']) || {}
  ).value;

  const dateTimeFormat = (
    getParticularPreferenceSettings(state, 'date_time_format', ['value']) || {}
  ).value;

  return {
    dateTimeFormat,
    timeFormat,
  };
};

export const DateTimeField = connect(mapStateToProps, { change })(
  DateTimeFiled
);
